//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ProducerService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Producer.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/producer/create', params || { });
	};

	//GeneratorFlag:[Producer.Delete]
	async delete(producerId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:producerId
		}
	
		return await _server.delete('/store/producer/delete', {'params':params})
	};

	//GeneratorFlag:[Producer.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/producer/detail', {'params':params});
	};

	//GeneratorFlag:[Producer.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/producer/list', {'params':params});
	};

	//GeneratorFlag:[Producer.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/producer/update', params || { });
	};

//GeneratorFlag:[NewAction]
}